import(/* webpackMode: "eager" */ "/workspace/src/app/compass/page.tsx")